import { ChartRasterDataSource } from '../chart-props';
import { Source } from './source';

export class RasterSource extends Source {
    private data!: ChartRasterDataSource;

    constructor(private readonly id: string) {
        super();
    }

    getBounds() {
        return this.data.bounds;
    }

    getValue(x: number, y: number): number[] | null {
        return this.data.getValue(x, y);
    }

    setData(data: ChartRasterDataSource) {
        this.setDirty();
        this.data = data;
    }

    hasData(): boolean {
        return !!this.data;
    }
}
